import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { useState, } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Error, SkipNavigationButton, Inspector, useHasDashboard, useDefaultTitle, } from 'react-admin';
import { AppLocationContext } from '../app-location';
import { ContainerLayoutContext } from './ContainerLayoutContext';
import { Header } from './Header';
/**
 * Layout component with no sidebar and a horizontal menu.
 *
 * @example
 * import { Admin, Resource } from 'react-admin';
 * import { ContainerLayout } from '@react-admin/ra-navigation';
 *
 * export const App = () => (
 *     <Admin dataProvider={dataProvider} layout={ContainerLayout}>
 *         <Resource name="songs" list={SongList} />
 *         <Resource name="artists" list={ArtistList} />
 *     </Admin>
 * );
 */
export var ContainerLayout = function (props) {
    var _a = props.appBar, appBar = _a === void 0 ? defaultAppBar : _a, children = props.children, className = props.className, errorComponent = props.error, menu = props.menu, toolbar = props.toolbar, maxWidth = props.maxWidth, fixed = props.fixed, userMenu = props.userMenu, sx = props.sx;
    var _b = useState(undefined), errorInfo = _b[0], setErrorInfo = _b[1];
    var handleError = function (error, componentStack) {
        setErrorInfo(componentStack);
    };
    var hasDashboard = useHasDashboard();
    var title = useDefaultTitle();
    return (_jsx(AppLocationContext, { children: _jsx(ContainerLayoutContext.Provider, { value: {
                hasDashboard: hasDashboard,
                title: title,
                menu: menu,
                toolbar: toolbar,
                userMenu: userMenu,
            }, children: _jsxs(StyledLayout, { className: clsx('layout', ContainerLayoutClasses.root, className), sx: sx, children: [_jsx(SkipNavigationButton, {}), appBar, _jsx(Container, { id: "main-content", className: ContainerLayoutClasses.content, maxWidth: maxWidth, fixed: fixed, children: _jsx(ErrorBoundary, { onError: handleError, fallbackRender: function (_a) {
                                var error = _a.error, resetErrorBoundary = _a.resetErrorBoundary;
                                return (_jsx(Error, { error: error, errorComponent: errorComponent, errorInfo: errorInfo, resetErrorBoundary: resetErrorBoundary }));
                            }, children: children }) }), _jsx(Inspector, {})] }) }) }));
};
var defaultAppBar = _jsx(Header, {});
var PREFIX = 'RaContainerLayout';
export var ContainerLayoutClasses = {
    root: "".concat(PREFIX, "-root"),
    content: "".concat(PREFIX, "-content"),
};
var StyledLayout = styled('div', {
    name: PREFIX,
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.palette.background.default,
        color: theme.palette.getContrastText(theme.palette.background.default),
        minHeight: "100vh",
    });
});
